import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/services/auth';
import { supabase } from '@/lib/supabase';
import { portalUser, portalRedirect, isPublicPortalPath } from '@/services/portal-access';
import { FullPageLoader } from '@/components/ui/PortalUI';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, isLoading, setUser, clearSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // Keep the callback synchronous: profile reads here can deadlock auth.
    // A profile is not required to seek purchase recovery. This creates no DB row.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) setUser(portalUser(session.user), session.access_token);
      else clearSession();
    });
    return () => subscription.unsubscribe();
  }, []);
  useEffect(() => {
    if (isLoading) return;
    const destination = portalRedirect(!!user, location.pathname);
    if (destination) navigate(destination, { replace: true });
  }, [user, isLoading, location.pathname]);
  if (isLoading) return <FullPageLoader label="Checking your BMC login…" />;
  if (!user && !isPublicPortalPath(location.pathname)) return null;
  return <>{children}</>;
}
